module.exports = __webpack_public_path__ + "img/soc.2d4e1a8e.svg";